var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMailCws(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 141.7 141.7",
    style: {
      enableBackground: "new 0 0 141.7 141.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.2 117.9h135V23.4H3.2v94.5zm118.2-82.6L73.9 82.7c-1.8 1.8-4.6 1.8-6.4 0L20.1 35.3h101.3zM15.2 40.5l33.4 33.4-33.4 28.4V40.5zm6.5 65.5 32-27.1 8.8 8.8c2.3 2.3 5.3 3.4 8.2 3.4s6-1.1 8.2-3.4l8.8-8.8 32 27.1h-98zm104.6-3.8L92.9 73.8l33.4-33.4v61.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailCws);
export default __webpack_public_path__ + "static/media/mailCWS.60f7bbe587d11fa940f3e5f38890c318.svg";
export { ForwardRef as ReactComponent };